export const deliveryStatusOptions = [
  {
    label: '待发货',
    value: 0,
  },
  {
    label: '部分发货',
    value: 1,
  },
  {
    label: '已发货',
    value: 2,
  },
  {
    label: '已取消',
    value: 4,
  },
];

export const receiveStatusOptions = [
  {
    label: '待收货',
    value: '1',
    en: 'waitReceiveCount',
  },
  {
    label: '部分收货',
    value: '2',
    en: 'partReceiveCount',
  },
  {
    label: '已收货',
    value: '3',
    en: 'allReceiveCount',
  },
];

export const collectionStatusOptions = [
  {
    label: '待收款',
    value: 1,
  },
  {
    label: '部分收款',
    value: 2,
  },
  {
    label: '已收款',
    value: 3,
  },
  {
    label: '已超收',
    value: 4,
  },
];

export const invoiceStatusOptions = [
  {
    label: '待开票',
    value: 1,
  },
  {
    label: '部分开票',
    value: 2,
  },
  {
    label: '全部开票',
    value: 3,
  },
];
